<template>
  <!-- 基本信息 -->
  <basic-info-module
    v-if="currentModuleId === BASIC_INFO_MODULE_ID"
    :mate-id="mateId"
    :is-saving="isSaving"
    @update:mate="updateMate"
    @update:is-saving="emit('update:isSaving', $event)"
  />
  <!-- 背景故事 -->
  <BgStoryModule
    :is-saving="isSaving"
    @update:is-saving="emit('update:isSaving', $event)"
    v-else-if="currentModuleId === BG_STORY_MODULE_ID"
  />
  <!-- 人际关系 -->
  <RelationModule
    :is-saving="isSaving"
    @update:is-saving="emit('update:isSaving', $event)"
    v-else-if="currentModuleId === RELATION_MODULE_ID"
  />
  <!-- 形象 -->
  <sprite-module
    :is-saving="isSaving"
    @update:is-saving="emit('update:isSaving', $event)"
    :show-header="false"
    v-else-if="currentModuleId === PERSONA_MODULE_ID"
  />
  <!-- 音色 -->
  <tone-module
    v-else-if="currentModuleId === TONE_MODULE_ID"
    :tone-id="mate.mateToneId"
    @update:tone-id="(mate.mateToneId = $event!), updateMate('mateToneId')"
  />
  <!-- 外貌特征 -->
  <FeatureModule
    v-else-if="currentModuleId === FEATURE_MODULE_ID"
    :mate-id="mateId"
  />

  <!-- 稿件 -->
  <MateGallery
    v-else-if="currentModuleId === GALLERY_MODULE_ID"
    :mate-id="mateId"
    enable-upload
    class="p-2"
  />
  <!-- 故事 -->
  <StoryModule v-else-if="currentModuleId === STORY_MODULE_ID" />

  <!-- 动态 -->
  <MomentModule :mate="mate" v-else-if="currentModuleId === MOMENT_MODULE_ID" />

  <!-- 合集 -->
  <CollectionList
    v-else-if="currentModuleId === COLLECTION_MODULE_ID"
    :mate-id="mateId"
  />

  <!-- 聊天对话 -->
  <ChatListModule
    v-else-if="currentModuleId === CHAT_LIST_MODULE_ID"
    :mate="mate"
  />

  <!-- OC 游戏 -->
  <GalGameModule
    v-else-if="currentModuleId === GAL_GAME_MODULE_ID"
    :mate-id="mateId"
    :is-my-mate="true"
  />
  <TimelineModule
    :entity-id="mateId"
    entity-type="mate"
    v-else-if="currentModuleId === TIMELINE_MODULE_ID"
    :entity-uuid="mate.uuid"
    :universe-id="mate.universeId"
    @update:is-saving="emit('update:isSaving', $event)"
  />

  <!-- 任务 -->
  <TaskList v-else-if="currentModuleId === TASK_MODULE_ID" />

  <SettingModule
    v-else-if="currentModuleId === SETTING_MODULE_ID"
    :mate="mate"
    @update:mate="updateMate"
  />
  <!-- 自定义模块 -->
  <CustomModule
    v-else-if="currentModuleId"
    :is-saving="isSaving"
    @update:is-saving="emit('update:isSaving', $event)"
    :module-id="currentModuleId"
  />
</template>

<script setup lang="ts">
import { useMate } from "@/stores/mate";
import {
  BASIC_INFO_MODULE_ID,
  BG_STORY_MODULE_ID,
  CHAT_LIST_MODULE_ID,
  COLLECTION_MODULE_ID,
  FEATURE_MODULE_ID,
  GAL_GAME_MODULE_ID,
  GALLERY_MODULE_ID,
  MOMENT_MODULE_ID,
  PERSONA_MODULE_ID,
  RELATION_MODULE_ID,
  STORY_MODULE_ID,
  TASK_MODULE_ID,
  TIMELINE_MODULE_ID,
  TONE_MODULE_ID,
} from "@/stores/module/moduleMate";
import { Mate } from "@/types/entity";
import { computed } from "vue";
import { SETTING_MODULE_ID } from "@/stores/module/moduleBase";

const props = defineProps<{
  mateId: number;
  currentModuleId: number;
  isSaving: boolean;
}>();

const mate = computed(() => {
  return mateStore.mateIdMap.get(props.mateId)!;
});
const emit = defineEmits<{
  (e: "update:isSaving", isSaving: boolean): void;
}>();

const mateStore = useMate();

type UpdateKey = keyof Mate | Array<keyof Mate>;

const updateMate = async (updateKey: UpdateKey) => {
  emit("update:isSaving", true);

  const params: Partial<Mate> = {};
  if (typeof updateKey === "string") {
    params[updateKey] = mate.value[updateKey];
  } else if (typeof updateKey === "object") {
    for (let i = 0; i < updateKey.length; i++) {
      const key = updateKey[i];
      params[key] = mate.value[key];
    }
  }

  await mateStore.updateMateDetail(mate.value.uuid!, params);
  emit("update:isSaving", false);
};
</script>
